export enum OENExtendedLoggingType {
  GENERIC,
  RATE,
}
